'use client';

import { useEffect, useState } from 'react';
import { useSiteConfig } from '@commons/SiteConfig';
import './_cookie-settings.scss';

/* Cookiebot arrives through GTM, so it isn't there when we mount, and its own
   load event doesn't fire on every failure path. Poll for the global instead —
   cheap, and it covers both. */
const POLL_INTERVAL = 500;
const POLL_ATTEMPTS = 20;

/**
 * "Informasjonskapsler" as a menu item.
 *
 * Cookiebot's floating badge in the lower-left corner is hidden (see
 * _cookie-settings.scss) — this button is the way back into the consent dialog.
 * Nothing renders until the script is actually there, so the menu never carries
 * an item that does nothing.
 */
export default function CookieSettings({ className = '' }) {
  const { dictionary } = useSiteConfig();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (window.Cookiebot) {
      setIsReady(true);
      return;
    }

    let attempts = 0;
    const timer = setInterval(() => {
      if (window.Cookiebot) {
        setIsReady(true);
        clearInterval(timer);
      } else if (++attempts >= POLL_ATTEMPTS) {
        clearInterval(timer);
      }
    }, POLL_INTERVAL);

    return () => clearInterval(timer);
  }, []);

  if (!isReady) return null;

  const handleClick = () => {
    // The menu is a native <dialog> in the top layer and Cookiebot's dialog is an
    // ordinary div — it would open *behind* the menu and be unclickable. Close
    // the menu first, then renew.
    document.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
    window.Cookiebot?.renew();
  };

  return (
    <button type="button" className={`CookieSettings ${className}`.trim()} onClick={handleClick}>
      {dictionary?.cookies?.settings || 'Informasjonskapsler'}
    </button>
  );
}
